module.exports = __webpack_public_path__ + "03_short_gray.1729e051.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/03_short_gray.png
// module id = HRmg
// module chunks = 0